import React, { Component } from 'react'
import ContentCard from './posts/view/content/ContentCard'
import Card from 'components/Card'
import { FormattedMessage } from 'react-intl'
import styles from './BioPage.css'

const BioDisplay = ({ bio_display, bio }) => {
  if (bio_display) {
    return <ContentCard key="content" post={{ content: bio_display }} />
  } else {
    // Using bio as a fallback. Most users will have a 'bio' that is
    // a short string extracted from the longer bio markup, however
    // very early users may still have a string in the bio field but
    // no bio_display field (because the bio string field used to be
    // the only bio).
    return (
      <Card className={styles.default_bio_card}>
        {bio ? (
          <span>{bio}</span>
        ) : (
          <FormattedMessage id="profile.their_short_bio_default" />
        )}
      </Card>
    )
  }
}

export default BioDisplay
